import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));


Sentry.init({
  dsn: "https://bbffa1d7a9594f60b6c28805dfd79fb1@appmon.ydigital.asia/1",
  environment: "development",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  tracesSampleRate: 0.01,
});
